import { elevation } from '@atlaskit/theme';
import styled from '@emotion/styled';
import React from 'react';
import { PageHeader } from '../../components/page-header';
import { FirstImpressionsFormView } from './first-impressions-form-view';
import { FirstImpressionsProductInfo } from './first-impressions-product-info';
import { FirstImpressionsImageUrls } from './types';
import { useFirstImpressionsState } from './use-first-impressions-state';

export function FirstImpressionsView() {
  const { firstImpressionsImageUrls, bundleData, bundleContent } =
    useFirstImpressionsState();
  return (
    <PageRoot firstImpressionsImageUrls={firstImpressionsImageUrls}>
      <PageHeader bundleData={bundleData} useDarkBackgroundMode={false} />
      <PageBody>
        <LeftColumn>
          <FirstImpressionsProductInfo bundleContent={bundleContent} />
        </LeftColumn>
        <RightColumn>
          <FirstImpressionsFormView />
        </RightColumn>
      </PageBody>
    </PageRoot>
  );
}

const PageRoot = styled.div<{
  readonly firstImpressionsImageUrls?: FirstImpressionsImageUrls;
}>`
  background-image: url(${(props) =>
    props.firstImpressionsImageUrls?.backgroundImage});
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;

  @media only screen and (max-width: 769px) {
    background-size: auto;
  }
`;

const PageBody = styled.div`
  flex: 1;
  max-width: 1440px;
  display: flex;
  align-items: flex-start;
  margin-top: 22px;
  @media only screen and (max-width: 769px) {
    width: 100%;
    flex-flow: row wrap-reverse;
    justify-content: center;
  }
`;

const LeftColumn = styled.div`
  margin: 16px;
  width: 448px;
  img {
    margin-bottom: 10px !important;
  }
`;

const RightColumn = styled.div`
  ${elevation.e200}
  margin: 16px;
  padding: 32px;
  background-color: white;
  box-sizing: content-box;
  width: 350px;
  align-items: center;
  border-radius: 8px;
  position: relative;

  @media only screen and (max-width: 420px) {
    box-shadow: unset;
    margin: 0;
    border-radius: 0;
  }
`;
